<template>
	<div class="page">
		<div class="breadcrumbs" v-if="state.breadcrumb.length > 0">
			<span class="breadcrumb current">
				<span class="breadcrumb back" v-on:click="state.editing = false; state.breadcrumb.splice(state.breadcrumb.length - 1);">
					<ErranditeIcon icon="angle-left"/>
				</span>
				<span class="breadcrumb" v-on:click="state.editing = false;">
					<span class="breadcrumbIcon" v-if="data.tasks[state.breadcrumb[state.breadcrumb.length-1]].tasks != undefined && data.tasks[state.breadcrumb[state.breadcrumb.length-1]].tasks.length > 0">
						<span class="circle project" v-bind:style="{'background-color': data.tasks[state.breadcrumb[state.breadcrumb.length-1]].colour}">
							<ErranditeIcon icon="folder"/>
						</span>
					</span>
					<span>{{ data.tasks[state.breadcrumb[state.breadcrumb.length-1]].label }}</span>
				</span>
				<span class="right" v-if="state.editing == false" v-on:click="state.editing = true">
					<ErranditeIcon icon="ellipsis-h"/>
				</span>
				<span class="right" v-if="state.editing == true" v-on:click="state.editing = false">
					<ErranditeIcon icon="save"/>
				</span>
			</span>
		</div>
		
		<ErranditeTaskPage v-if="data.tasks[task].tasks.length == 0 || state.editing == true" v-bind:data="data" v-bind:state="state" v-bind:task="task"/>

		<ul class="tasks padded" v-if="state.editing == false">
			<ErranditeTask v-for="subtask in data.tasks[task].tasks" v-bind:key="subtask" v-bind:task="subtask" v-bind:state="state" v-bind:data="data"/>
		</ul>

	</div>
</template>

<script>
import ErranditeTask from "./ErranditeTask.vue";
import ErranditeTaskPage from "./ErranditeTaskPage.vue";

import ErranditeIcon from "./ErranditeIcon.vue";

export default {
  name: "ErranditePage",
  props: {
    task: String,
    state: Object,
    data: Object
  },
  components: {
	ErranditeTask,
	ErranditeTaskPage,
	ErranditeIcon
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../styles/_variables.scss";

#errandite {

	.taskPage {
		padding: $padding;
	}

	ul.tasks.padded {
		padding-bottom: $padding*3.5 + $addSize;
		padding-bottom: calc(#{$padding*3.5 + $addSize} +  env(safe-area-inset-bottom));
	}

}


.taskpage-enter-active, .taskpage-leave-active {
  transition: all 1s;
}
.taskpage-enter, .taskpage-leave-to /* .list-leave-active below version 2.1.8 */ {
  filter: blur(10px);
  transform: translateY(100%);
}
</style>
